module.exports = __webpack_public_path__ + "assets/images/albom6.f6ec33da.jpg";